module.exports = __webpack_public_path__ + "media/images/fallback/facebook_email_social_icons-f7dd6494f5d72f6249c73a48296939a7.png";